import React, { useState } from "react";
import { Accordion, Offcanvas } from "react-bootstrap";
import GlobalAccounts from "./GlobalAccounts";
import Wallets from "./Wallets";
import AccountStatement from "./AccountStatements";
import styles from "./AccountDetail.module.css";
import { lienReportDownload, balanceConfirmationDownload } from "../../api";
import { Spinner } from "react-bootstrap";
import download from "../../public/images/download.svg";
import withFeatureActions from "../../withFeatureActions";
import ConversionFlow from "./ConversionFlow";

const LienAccountDetails = ({ userId, detail, featureAccess }) => {
  const [activeKey, setActiveKey] = useState("0");
  const [accountId, setAccountId] = useState(null);
  const [accountStatus, setAccountStatus] = useState(null);
  const [globalLoading, setGlobalLoading] = useState(false);
  const [balanceLoading, setBalanceLoading] = useState(false);
  const [walletUpdate, setWalletUpdate] = useState(0);
  const [showConversion, setShowConversion] = useState(false);
  const [hasBalance, setHasBalance] = useState(false);
  const isApproved = accountStatus === "APPROVED";
  const { writeAccess, modifyAccess } = featureAccess;

  const handleToggle = (key) => {
    setActiveKey(activeKey === key ? null : key);
  };

  const downloadPdf = async () => {
    setGlobalLoading(true);
    try {
      const payload = {
        accountStatementType: "GENERAL",
        accountId: accountId,
      };

      const resp = await lienReportDownload(payload);

      if (resp?.status === 200 && resp?.data) {
        const blob = new Blob([resp.data], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.download = "AccountOpeningLetter.pdf";
        link.click();

        window.URL.revokeObjectURL(url);
      }
    } catch (error) {
      console.error("Download Error:", error);
    }
    setGlobalLoading(false);
  };

  const balanceConfirmationDownloadPdf = async () => {
    setBalanceLoading(true);
    try {
      const resp = await balanceConfirmationDownload(userId, "GLOBAL_LIEN");

      if (resp?.status === 200 && resp?.data) {
        const blob = new Blob([resp.data], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = "BalanceConfirmation.pdf";
        link.click();

        window.URL.revokeObjectURL(url);
      }
    } catch (error) {
      console.error("Download Error:", error);
    }
    setBalanceLoading(false);
  };

  return (
    <div className={styles.accountDetailContainer}>
      <Accordion activeKey={activeKey} className={styles.accordionContainer}>
        <Accordion.Item eventKey="0">
          <Accordion.Header
            onClick={() => handleToggle("0")}
            className={styles.accordionHeader}
          >
            <div className={styles.HeaderButton}>
              <span>Global Account</span>
              <div>
                {writeAccess && accountId && accountStatus === "APPROVED" && (
                  <span
                    className={styles.DownloadButton}
                    onClick={(e) => {
                      e.stopPropagation();
                      downloadPdf();
                    }}
                  >
                    {globalLoading ? (
                      <Spinner
                        animation="border"
                        size="sm"
                        className={styles.spinnerButton}
                      />
                    ) : (
                      <img
                        src={download}
                        alt="download"
                        className={styles.iconButton}
                      />
                    )}
                    Account Opening Letter
                  </span>
                )}
              </div>
            </div>
          </Accordion.Header>
          <Accordion.Body className={styles.accordionBody}>
            <GlobalAccounts
              userId={userId}
              apiType="partner"
              onAccountId={(id) => setAccountId(id)}
              onAccountStatus={(s) => setAccountStatus(s)}
            />
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="1" style={{ marginTop: "20px" }}>
          <Accordion.Header
            onClick={() => handleToggle("1")}
            className={styles.accordionHeader}
          >
            <div className={styles.HeaderButton}>
              <span>Wallets</span>
              <div>
                {writeAccess && isApproved && (
                <span
                  className={styles.DownloadButton}
                  onClick={(e) => {
                    e.stopPropagation();
                    balanceConfirmationDownloadPdf();
                  }}
                >
                  {balanceLoading ? (
                    <Spinner
                      animation="border"
                      size="sm"
                      className={styles.spinnerButton}
                    />
                  ) : (
                    <img
                      src={download}
                      alt="download"
                      className={styles.iconButton}
                    />
                  )}
                  Balance Confirmation Letter
                </span>
                )}
                {modifyAccess && isApproved && hasBalance && (
                  <span
                    className={styles.DownloadButton}
                    onClick={(e) => {
                      e.stopPropagation();
                      setShowConversion(true);
                    }}
                  >
                    Conversion
                  </span>
                )}
              </div>
            </div>
          </Accordion.Header>
          <Accordion.Body className={styles.accordionBody}>
            <Wallets
              userId={userId}
              apiType="partner"
              accountStatus={accountStatus}
              refreshKey={walletUpdate}
              onHasBalance={setHasBalance}
            />
          </Accordion.Body>
        </Accordion.Item>
        {writeAccess && isApproved && (
        <Accordion.Item eventKey="2" style={{ marginTop: "20px" }}>
          <Accordion.Header
            onClick={() => handleToggle("2")}
            className={styles.accordionHeader}
          >
            Account Statement
          </Accordion.Header>
          <Accordion.Body className={styles.accordionBody}>
            <AccountStatement userId={userId} accountType="GLOBAL_LIEN" isActive={activeKey === "2"}/>
          </Accordion.Body>
        </Accordion.Item>
        )}
      </Accordion>

      <Offcanvas
        show={showConversion}
        onHide={() => setShowConversion(false)}
        placement="end"
        className={styles.offcanvas}
        style={{ color: "white", backgroundColor: "#28282B", width: "650px" }}
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title style={{ color: "white" }}>Conversion</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body style={{ padding: 0 }}>
          <ConversionFlow
            userId={userId}
            apiType="partner"
            detail={detail}
            onClose={() => {
              setShowConversion(false);
              setWalletUpdate((prev) => prev + 1);
            }}
          />
        </Offcanvas.Body>
      </Offcanvas>
    </div>
  );
};

export default withFeatureActions(LienAccountDetails, "MCB", "Lien Account Details");
